import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedId } from "../../store/slices/permissionGrid/permissionGridSlice";
import { useFetchDayoffDocumentsQuery } from "../../store";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { DOCUMENT_DIALOG } from "../../store/slices/utils/dialogEnum";
import { closeDialog } from "../../store/slices/dialog/dialogSlice";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import FolderIcon from "@mui/icons-material/Folder";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import Loading from "./Loading";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const DocumentDialog = () => {
  const dispatch = useDispatch();
  const { selectedId } = useSelector((state) => state.permissionGridSlice);
  const { documentDialogOpen } = useSelector((state) => state.dialogSlice);

  const { data, isLoading } = useFetchDayoffDocumentsQuery(selectedId, {
    refetchOnMountOrArgChange: true,
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    dispatch(setSelectedId(null));
    dispatch(closeDialog(DOCUMENT_DIALOG));
  };

  const download = ({ fileName, documentTypeName }) => {
    fetch(
      `${process.env.REACT_APP_BASE_ENDPOINT}api/dayoff/download-document?fileName=${fileName}`
    ).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = documentTypeName;
        alink.click();
      });
    });
  };

  if (isLoading) return <Loading isLoading={isLoading} />;

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={documentDialogOpen}
      fullScreen={fullScreen}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 0,
          m: 1,
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          textAlign: "center",
          fontWeight: 700,
          fontSize: { xs: "1.2rem", sm: "1.5rem" },
          bgcolor: "primary.main",
          color: "#fff",
        }}
        id="customized-dialog-title"
      >
        Belgeler
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          bgcolor: "background.default",
          p: { xs: 1, sm: 2 },
        }}
      >
        {data?.data?.length === 0 ? (
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              color: "text.secondary",
              py: 4,
            }}
          >
            Yüklü belge bulunamadı.
          </Typography>
        ) : (
          <Paper
            elevation={0}
            sx={{
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 1,
              p: { xs: 0, sm: 1 },
            }}
          >
            <List dense>
              {data?.data.map((item, idx) => (
                <React.Fragment key={item.id}>
                  <ListItem
                    disablePadding
                    secondaryAction={
                      <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={() => download(item)}
                        sx={{ minWidth: 90 }}
                      >
                        İndir
                      </Button>
                    }
                  >
                    <ListItemButton onClick={() => download(item)}>
                      <ListItemIcon>
                        <FolderIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: { xs: "1rem", sm: "1.1rem" },
                            }}
                          >
                            {item.documentTypeName}
                          </Typography>
                        }
                        secondary={
                          item.fileName && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ wordBreak: "break-all" }}
                            >
                              {item.fileName.length > 15
                                ? item.fileName.substring(0, 15) + "..."
                                : item.fileName}
                            </Typography>
                          )
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                  {idx < data.data.length - 1 && <Divider component="li" />}
                </React.Fragment>
              ))}
            </List>
          </Paper>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DocumentDialog;
